(function ($) {

    var enterState = true;

    ///////////////      INITIALIZATION     //////////////////////
    this.init = function () {

        splitSubnav();
        initKeyNav();

        // Search Launch
        $(".headernav-mobile-bars-searchicon").on("click", ToggleYextMobileHeaderSearch);
        // EVENT HANDLING //

        // When you enter a level1 item - make sure we pop level 2 (and close all sibling level 2 menus)
        $(".headernav-desktop .main_menu_new").mouseenter(enterMainNav)
            .mouseleave(leaveMainNav);

        // When you enter a level2 item - make sure we pop level 2 (and close all sibling level 2 menus)
        $(".headernav-desktop .inner_menu_items").mouseenter(enterNav)
            .mouseleave(leaveNav);

        $(".level1-item-link-a").hover(function (event) {
            openLevel2(event)
        });
        $(".level1-item-link-a").focus(function (event) {
           // console.log("focus in ");
            $(".inner_menu_items").removeClass("hover")
            $(event.currentTarget).closest(".inner_menu_items").addClass("hover");
            $(".sub_menu_link[aria-expanded=true]").attr("aria-expanded", "false");
            $(this).attr("aria-expanded", "true");
            openLevel2(event);
        });

        $(".level2 a").focus(function (event) {
            //console.log("focus in ");
            $(".inner_menu_items").removeClass("hover");
            $(".sub_menu_link[aria-expanded=true]").attr("aria-expanded", "false");
            $(event.currentTarget).closest(".inner_menu_items").addClass("hover");
            openLevel2(event)
        });
        // Close the nav when focus is given outside of the nav
        $(".headernav .main_menu_new").focusin(enterMainNav)
            .focusout(leaveMainNav);
       //mainNavHover();
       

        // Level 1, 2, and 3 keyboard handler
        $(".headernav-desktop").find(".level1-item-link-a, .level2-item-link, .level3-item-link, .level2-item-promolink, .level2-right-promo, .headernav-desktop-nav-icons-item > a, .nav-promo-CTA-container .primary-button").on("keydown", menuKeyNav);

        // Init Maxheight of Internal Nav
       //$(".headernav-desktop .level2").css("max-height", window.outerHeight - 100 + "px");

        // set up keyboard nav
        configureMobileKeyNav();

        // attach event handlers
        $(".headernav-mobile a.level1-item-link-a, .headernav-mobile .level2-item-link-a").keydown(handleKeyboard);

        // make sure that the right key hits the next landmark
        $(".headernav-desktop-global a").first().addClass("afternav");

        $("#mobile-menu-open").click(toggleMobileNav);

       
        $(".headernav-desktop .level2-item-link").mouseenter(openThisLevel3).focusin(openThisLevel3);

        initMobileNav();

        // Header Search (desktop)
        initHeaderDesktopSearch();

        // Handle Scrolling While the Nav is Open
        $(window).on("scroll", handleHeaderScroll);
    };

    function splitSubnav() {
        $(".level3-list").each(function () { 

        var originalUl = $(this).find(".sub-menu-list_ites");
        var items = originalUl.find("li");
        var groupConfig = {
            // Number of groups are the length of arrey.
            //itemsPerGroup: [15, 30, 5],  // Number of items in each group
            itemsPerGroup: $(this).data("group").split(",").map(function (item) {
                return parseInt(item);
            })

        };

        var totalItems = items.length;
        var groupIndex = 0;
        var startIndex = 0;

        while (groupIndex < groupConfig.itemsPerGroup.length && startIndex < totalItems) {
            var itemsInGroup = groupConfig.itemsPerGroup[groupIndex];
            var endIndex = startIndex + itemsInGroup;

            if (endIndex > totalItems) {
                endIndex = totalItems;
            }

            var groupItems = items.slice(startIndex, endIndex);
            var newUl = $("<ul>").addClass("sub-menu-list_ites");
            newUl.append(groupItems);
            originalUl.before(newUl);
            startIndex = endIndex;
            groupIndex++;
        }
            originalUl.remove();
        });
        $('.sub-menu-list_ites').each(function () { $(this).find('li:first:not(:has(.level3-item-headline))').addClass('li-wrap') });
    }
    function mainNavHover() {
        $('.main_menu_new.has-children').hover(function () {
            // When the mouse enters the .main_menu_new.has-children element
            $(this).addClass('hover'); // Add the 'hover' class
            $('.header-spacer').css('margin-top', $(this).find(".headernav-desktop-nav").height()); // Add margin-top to .saparator
        }, function () {
            // When the mouse leaves the .main_menu_new.has-children element
            $(this).removeClass('hover'); // Remove the 'hover' class
            $('.header-spacer').css('margin-top', '0'); // Reset margin-top for .saparator
        });
    }
    function handleHeaderScroll(e) {
        var $level2 = $(".level2-visible");
        if ($level2.length > 0) {
            var CurrentScrollTop = window.scrollY;
            var OldScrollTop = parseInt($level2.attr("originaltop"));
            var differential = CurrentScrollTop - OldScrollTop;
            var NavCurrentTop = parseInt($level2.css("top"));
            var HeaderHeight = $(".header").get(0).offsetHeight;
            var NavHeight = $level2.get(0).offsetHeight;

            if (differential < 0) {
                // if we are scrolling up

                if (NavCurrentTop >= HeaderHeight) {
                    // and if we are fully unfurled
                    $level2.css("top", HeaderHeight + "px");
                } else {
                    // else if we are not fully unfurled
                    if (NavCurrentTop - differential > 100) {
                        // if new scroll value would get us over 100, then put us at 100
                        $level2.css("top", HeaderHeight + "px");
                    } else {
                        // else put us at the new value
                        $level2.css("top", NavCurrentTop - differential + "px");
                    }
                }
            } else if (differential > 0) {
                // If the nav is scrolled away, then close it
                if ($level2.offset().top + NavHeight < $(".header").offset().top + 80) {
                    closeLevel2();
                } else {
                    $level2.css("top", NavCurrentTop - differential + "px");
                }
            }


            // UPDATE OLD SCROLLTOP ON LEVEL2 ELEMENT
            $level2.attr("originaltop", window.scrollY);
        }
    }

    function initMobileNav() {

        var $parentLevel;


        $('.mobile-nav .has-children>a').click(function (e) {
            e.stopPropagation();
        });

        $(".level1-item-link-a, .level2-item-link-a").attr("aria-expanded", false);

        $(".mobile-nav .mobile-nav-menulink").click(function () {
            CloseMobileLevel2();
            OpenMobileLevel1();
        });

        $('.mobile-nav .level1-item.has-children .level1-collapse').click(function (e) { // Level 1 clicks

            $parentLevel = $(this).parents(".level1-item");

            $parentLevel.siblings('.open').removeClass('open')
                .find('.level2').slideUp(0, 'swing', null)
                .find('.level2-item.has-children.open').removeClass('open')
                .find('.level3').slideUp(0, 'swing', null);

            if (!$parentLevel.hasClass('open')) {
                e.preventDefault();
                OpenMobileLevel2($(this));

            } else if ($parentLevel.hasClass('open')) {
                CloseMobileLevel2();
                OpenMobileLevel1();
            }
        });

        $(".mobile-nav .mobileNav-levelLink").click(function (e) {
            CloseMobileLevel3();
        });

        $('.mobile-nav .level2-item.has-children .level2-collapse').click(function (e) { // Level 2 clicks

            $parentLevel = $(this).parents(".level2-item");

            $(".mobile-nav .level2-item-link-a").attr("aria-expanded", false);

            $parentLevel.siblings('.open').removeClass('open')
                .find('.level3').slideUp(0, 'swing', null);
            if (!$parentLevel.hasClass('open')) {
                e.preventDefault();
                OpenMobileLevel3($(this));

            } else if ($parentLevel.hasClass("open")) {
                CloseMobileLevel3();

            }
        });

        $(".mobile-nav .level1-item.has-children").click(function () {
            if (!$(this).hasClass("open")) {
                $(this).find(".level1-collapse").click();
                event.preventDefault();
            }
        });
        $('.mobile-nav .level2-item.has-children .level2-item-link-a').click(function (e) { 
            $(this).next('a.level2-collapse').click();
        });
        $(".dropdown-toggle.mobile-global-link").click(function (event) {
            if ($(this).attr("aria-expanded") == "true") {
                setTimeout(function () {
                    $("a.mobile-global-redirect-link").click();
                }, 500);
            } 
        });        
    }

    function OpenMobileLevel1() {
        $(".mobile-nav .level1-item").removeClass("hideMobile");
        $(".mobile-nav .mobile-global").removeClass("hideMobile");
    }

    function OpenMobileLevel2(target) {
        $parentLevel = $(target).parents(".level1-item");
        $(".mobile-nav .mobile-nav-menulink").removeClass("hideMobile");
        $parentLevel.siblings().addClass("hideMobile");
        $parentLevel.addClass('open').find('> .level2').slideDown(0, 'swing', null);
    }
    function CloseMobileLevel2() {
        $(".mobile-nav .mobile-nav-menulink").addClass("hideMobile");
        $(".mobile-nav .level1-item").removeClass('open')
            .find('.level2').slideUp(0, 'swing', null)
            .find('.level2-item.has-children.open').removeClass('open')
            .find('.level3').slideUp(0, 'swing', null);
    }

    function OpenMobileLevel3(target) {
        $parentLevel = $(target).parents(".level2-item");
        $parentLevel.find(".mobileNav-levelLink").removeClass("hideMobile");
        $(".mobile-nav .mobile-nav-menulink").addClass("hideMobile");
        $(target).parents(".level1-item").children(".level1-item-link.navitem").addClass("hideMobile");
        $parentLevel.siblings().addClass("hideMobile");
        $parentLevel.addClass('open')
            .find('> .level3')
            .slideDown(0, 'swing', null);

        $parentLevel.find(".nav-promo").removeClass("hideMobile");
    }
    function CloseMobileLevel3() {
        $(".mobile-nav .mobileNav-levelLink").addClass("hideMobile");
        $('.mobile-nav .level2-item.open .level3').slideUp(0, 'swing', null)
            .find('.level3-item.has-children.open').removeClass('open');
        $(".mobile-nav .mobile-nav-menulink").removeClass("hideMobile");
        $(".mobile-nav .level1-item.open .level1-item-link.hideMobile").removeClass("hideMobile");
        $(".mobile-nav .level2-item").removeClass("hideMobile");
        $(".mobile-nav .level2-item.open").removeClass("open");
        $(".mobile-nav .nav-promo").addClass("hideMobile");
    }

    function ToggleYextMobileHeaderSearch() {
        if ($("#MobileYextLaunch").hasClass("shown")) {
            CloseMobileYextSearch();
        } else {
            OpenMobileYextSearch();
        }
    }
    function OpenMobileYextSearch() {
        $("#MobileYextLaunch").addClass("shown").attr("aria-expanded", true);
        $(".headernav-mobile-search").show();
        $(".headernav-mobile-search").find("input").focus();

    }

    function CloseMobileYextSearch() {
        $("#MobileYextLaunch").removeClass("shown").attr("aria-expanded", false);
        $(".headernav-mobile-search").hide();

    }

    function handleKeyboard(event) {


        if (event.which === 37) {
            // left - if this item is open, we close it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find("> .collapse-open").length > 0) {
                    $(event.currentTarget).parent().find("> .collapse-open")[0].click();
                } else if ($(event.currentTarget).parent().find("> .level2-collapse-open").length > 0) {
                    $(event.currentTarget).parent().find("> .level2-collapse-open")[0].click();
                }

            }
            event.preventDefault();

        } else if (event.which === 39) {
            // right - if this item is closed, open it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find("> .collapse-closed").length > 0) {
                    $(event.currentTarget).parent().find("> .collapse-closed")[0].click();
                } else if ($(event.currentTarget).parent().find("> .level2-collapse-closed").length > 0) {
                    $(event.currentTarget).parent().find("> .level2-collapse-closed")[0].click();
                }
            }
            event.preventDefault();

        } else if (event.which === 27) {
            $("#mobile-menu-open")[0].click();
        }
    }

    function configureMobileKeyNav() {

        var $this, $that, $thisLink, $thatLink;

        var $mobileNav = $(".mobile-nav");

        $mobileNav.find(".level1-item").each(function (index) {
            $this = $(this);

            $thisLink = $this.find("a.level1-item-link-a");


            // set up the aria label on level 1 links
            if (index === 0) {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + ". To use nav, press right arrow key to expand submenu items. Press left to close. Use Tab and shift tab to navigate to next and previous items. Press escape to exit nav");
            } else {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + " with " + $this.find(".level2-item").length + " children");
            }

            // hide the + or - if there are no children

            if (!$this.hasClass("has-children")) {
                $this.find(".level1-collapse").remove();
            }


            $this.find(".level2-item").each(function (jindex) {
                $that = $(this);
                $thatLink = $that.find(".level2-item-link-a");

                $thatLink.attr("aria-label", "Second Level Menu Item: " + $thatLink.text() + " with " + $that.find(".level3-item").length + " children");

                if (!$that.hasClass("has-children")) {
                    $this.find(".level2-collapse").remove();
                }

                $that.find(".level3-item").each(function () {

                    $(this).find("a").attr("aria-label", "Third Level Menu Item: " + $(this).find("a").text());

                });

            });

        });
    }


    ///////////////      KEYBOARD NAV      ///////////////////////
    function initKeyNav() {
        var that,
            y = 0,
            z = 0;

       
        $(".headernav-desktop .main_menu_new").each(function (i) {
            that = this;
            $(this).find(".level1-item-link-a").attr("nav-index-x", i).attr("nav-index-y", y).attr("nav-index-z", z);
            $(this).find(".level1-item").each(function () {
                y++;
                $(this).find(".level1-item-link-a").attr("nav-index-x", i).attr("nav-index-y", y).attr("nav-index-z", z);
                $("#level3-" + $(this).find(".level1-item-link-a").data("level3-id")).find(".level3-item-link").each(function (k) {
                    z++;
                    $(this).attr("nav-index-x", i).attr("nav-index-y", y).attr("nav-index-z", z);
                });
                $("#level3Promo-" + $(this).find(".level1-item-link-a").data("level3-id")).find(".nav-promo-CTA-container .primary-button").attr("nav-index-x", i).attr("nav-index-y", y).attr("nav-index-z", (z + 1)); //promo CTA navigability
                z = 0;
            });
            $(this).find(".headernav-desktop-nav-icons-item").each(function () {
                y++;
                $(this).find("a").attr("nav-index-x", i).attr("nav-index-y", y);
            })

            y = 0;
        });
    }
    function menuKeyNav(event) {

        var $item, itemX, itemY, itemZ;

        stopThaProp(event);

        $item = $(event.currentTarget);
        itemX = $(event.currentTarget).attr("nav-index-x") - 0;
        itemY = $(event.currentTarget).attr("nav-index-y") - 0;
        itemZ = $(event.currentTarget).attr("nav-index-z") - 0;

        switch (event.originalEvent.which) {
            
            case 37:
                // left
                if (itemY == 0 && itemX > 0) {
                    $(".headernav").find('[nav-index-x="' + (itemX - 1) + '"][nav-index-y="0"][nav-index-z="0"]').focus();
                }
                if (itemZ > 0) {
                    $(".headernav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + itemY + '"][nav-index-z="' + (itemZ - 1) + '"]').focus();
                }
                break;
            case 38:
                // up 
                if (itemY > 0) {
                    $(".headernav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY - 1) + '"][nav-index-z="0"]').focus();
                }
                event.preventDefault();

                break;
            case 39:
                // right
                if (itemY == 0) {
                    $(".headernav").find('[nav-index-x="' + (itemX + 1) + '"][nav-index-y="0"][nav-index-z="0"]').focus();
                } else {
                    $(".headernav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + itemY + '"][nav-index-z="' + (itemZ + 1) + '"]').focus();
                }
                break;
            case 40:
                // down 
                $(".headernav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY + 1) + '"][nav-index-z="0"]').focus();
                event.preventDefault();
                break;
           
        }
    }

    function enterMainNav(event) {
       // console.log(event.currentTarget);
        closeMainLevel1(event);
        openMainLevel1(event);
    }
    function leaveMainNav(event) {
        //console.log("menu close" + event.currentTarget);
        closeMainLevel1(event);
    }


    //////////////        FOCUS HANDLING   ///////////////////////
    function enterNavCheck(event) {
        if ($(':focus').hasClass("level1-item-link-a")) {
            enterNav(event);
        }
    }
    function leaveNavCheck(event) {
        if (!$(event.relatedTarget).parents('.level1-item').length) {
            leaveNav(event);
        }
    }
    function enterNav(event) {
       // closeLevel2(event);
        openLevel2(event);
    }
    function leaveNav(event) {
        closeLevel2(event);
    }
    function openLevel2(event) {
        //console.log(event.currentTarget);
        if ($(event.currentTarget).hasClass("level1-item")) {
            $(event.currentTarget).addClass("hover"); 
            $(event.currentTarget).find(".sub_menu_link").attr("aria-expanded", "true");
            $(event.currentTarget).find(".level2").addClass("level2-visible").removeClass("level2-hidden").attr("originaltop", window.scrollY).css("top", $(".header").get(0).offsetHeight + "px");
            openLevel3($(event.currentTarget).find(".level2-item-link")[0]);
            //console.log("openLevel2 if");
        } else {
            $(event.currentTarget).parents(".inner_menu_items").find(".level2").addClass("level2-visible").removeClass("level2-hidden").attr("originaltop", window.scrollY).css("top", $(".header").get(0).offsetHeight + "px");
            openLevel3($(event.currentTarget).find(".level2-item-link")[0]);
            $(event.currentTarget).addClass("hover"); 
            //console.log("openLevel2 else");
        }
    }

    function closeLevel2(event) {
        $(event.currentTarget).removeClass("hover");
        $(".sub_menu_link[aria-expanded=true]").attr("aria-expanded", "false");
        $(event.currentTarget).find(".level2").removeClass("level2-visible").addClass("level2-hidden");
        if ($(event.currentTarget).hasClass('hover')) {
            $(".headernav-desktop .level2-item-link").removeClass("level2-open");
            $(".headernav-desktop").find(".sub_menu_link[aria-expanded=true]").attr("aria-expanded", "false");
            $(".headernav-desktop .level2-visible").addClass("level2-hidden").removeClass("level2-visible").attr("originaltop", "");
            //console.log("closeLevel2 if");
        }
    }

    function openMainLevel1(event) {
        $(event.currentTarget).addClass('hover');
        if ($(event.currentTarget).hasClass("main_menu_new")) {
            $(event.currentTarget).find(".main_menu_link").attr("aria-expanded", "true");
            $(event.currentTarget).find(".headernav-desktop-nav").addClass("level2-visible").removeClass("level1-hidden").attr("originaltop", window.scrollY).css("top", $(".header").get(0).offsetHeight + "px");
            //console.log("openMainLevel1 if");
        } else {
            $(event.currentTarget).parents(".main_menu_new").find(".headernav-desktop-nav").addClass("level1-visible").removeClass("level2-hidden").attr("originaltop", window.scrollY).css("top", $(".header").get(0).offsetHeight + "px");
        }
    }

    function closeMainLevel1() {
        $(".main_menu_new").removeClass('hover');
        $(".headernav-desktop .level2-item-link").removeClass("level2-open");
        $(".headernav-desktop").find(".main_menu_link[aria-expanded=true]").attr("aria-expanded", "false");
        $(".headernav-desktop .level2-visible").addClass("level2-hidden").removeClass("level2-visible").attr("originaltop", "");
        //console.log("closeMainLevel1");
    }


    function openThisLevel3(e) {
        openLevel3(e.currentTarget);
    }
    function openLevel3(level2Link) {
        $(".level2-item-link").removeClass("level2-open");
        $(level2Link).addClass("level2-open");
        $(".level3.list-unstyled").removeClass("level3-open");
        $(".headernav-desktop .nav-promo").removeClass("show-promo");
        $("#level3-" + $(level2Link).data("level3-id")).addClass("level3-open");
        $("#level3Promo-" + $(level2Link).data("level3-id")).addClass("show-promo");
    }
    //////////////       UTILITY       ///////////////////////
    function stopThaProp(event) {
        event.stopPropagation();
    }

    function hideMobileNav() {
        if ($(".embeddedServiceHelpButton").length > 0) {
            $(".embeddedServiceHelpButton").show();
        }
        $("#mobile-nav").hide().removeClass("shown");
        $("#mobile-menu-open").removeClass("open");
        setTimeout(function () {
            $("#mobile-nav").removeClass("shown");
        }, 350);
    }

    function showMobileNav() {
        if ($(".embeddedServiceHelpButton").length > 0) {
            $(".embeddedServiceHelpButton").hide();
        }
        $("#mobile-nav").show();
        $("#mobile-menu-open").addClass("open");
        setTimeout(function () {
            $("#mobile-nav").addClass("shown");
        }, 50);

    }

    function toggleMobileNav() {
        CloseMobileYextSearch();

        if ($("#mobile-nav").css("display") === "none") {
            showMobileNav();
        } else {
            hideMobileNav();
        }
    }


    /*******************************************************************
     Header Search (Desktop)
    *******************************************************************/

    var $headerNav = $('.headernav');
    var $headerNavDesktop = $('.headernav-desktop');
    var $headerSearchBar = $('.headernavsearchbar');
    var $headerSearchButton = $('.headernav-desktop .site-search-button');
    var $headerSearchPaneDesktop = $(".new_headernav-desktop .headernav-desktop-global-bottom");


    function initHeaderDesktopSearch() {
        $headerSearchButton.click(function (e) {
            e.stopPropagation();

            if ($headerSearchBar.is(':visible'))
                hideHeaderDesktopSearch();
            else
                showHeaderDesktopSearch();
        });

        $headerSearchBar.click(function (e) {
            e.stopPropagation();
        });

        $('.headernavsearchbar-desktop-close').click(function () {
            hideHeaderDesktopSearch();
        });

        $('html').click(function () {
            hideHeaderDesktopSearch();
        });
    }

    function showHeaderDesktopSearch() {        
        $headerSearchBar.show();
        $headerNav.addClass('headernav-searchopen');
        $headerSearchButton.addClass('site-search-button-open');
        $headerNavDesktop.addClass('headernav-desktop-searchopen');
        $headerSearchButton.attr('aria-expanded', 'true');
        $headerSearchPaneDesktop.find('a').attr('tabindex', '-1');
        updateHeaderSpaceForSearch();
    }

    function hideHeaderDesktopSearch() {        
        if ($headerSearchBar.is(':visible')) {
            $headerSearchBar.hide();
            $headerNav.removeClass('headernav-searchopen');
            $headerSearchButton.removeClass('site-search-button-open');
            $headerNavDesktop.removeClass('headernav-desktop-searchopen');
            $headerSearchButton.attr('aria-expanded', 'false');
            $headerSearchPaneDesktop.find('a').removeAttr('tabindex', '0');
            updateHeaderSpaceForSearch();
        }
    }

    function updateHeaderSpaceForSearch() {
        var headerHeight = $(".new_header").height();

        if ($headerSearchBar.is(':visible')) {
            // Set the top of the search bar calculating whether any temp alerts are displayed.
            $headerSearchBar.css({ top: headerHeight });
            headerHeight += $(".headernavsearchbar").height();
        }
       /* $(".header-spacer").height(headerHeight);*/
    }

    this.init();

})(jQuery);

var App = App || {};
